import api from '../../server';

export default {
  namespaced: true,
  state: {
    home: {
      products:[],
      banners:[]
    },
  },
  actions:{
    fetchHomeData({commit}, {params}) {
      return api.Home(params).then(data => commit('setHomeData', {data}))
    }
  },
  mutations: {
    setHomeData(state,data){
      state.home = data.data.data
    }
  }
}
